export default ({
  openModalAction,
  createFeedbackModal,
  isMobile,
  fail,
  failMethod,
  feedback,
  title,
  isFromUpdate = false,
  poiNamesList = null,
  mycasaDomain = null,
  isFromLogin = false,
  getSearchesList = null,
  disableHistoryBackOnClose = false,
}) => {
  openModalAction(createFeedbackModal({
    isMobile,
    fail,
    failMethod,
    feedback,
    title,
    isFromUpdate,
    poiNamesList,
    mycasaDomain,
    isFromLogin,
    getSearchesList,
    disableHistoryBackOnClose,
  }));
};
